module.exports = __webpack_public_path__ + "img/PL10037.e3dae874.png";